/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import UiJsonApiClient from "../../../Basis/Api/UiJsonApiClient";

export interface Konto {
    kontoId: string;
    eMail: string;
    land: string;
    status: Kontostatus;
    mandant: string;
    faehigkeiten: KontoFaehigkeiten;
}

export type Kontostatus =
    | "AKTIV"
    | "ANGABENERFORDERLICH"
    | "EINGESCHRAENKT"
    | "GEBUEHRENDEAKTIVIERT"
    | "AUSZAHLUNGENDEAKTIVIERT";

export interface KontoLink {
    url: string;
    gueltigBis: string;
}

export type KontoFaehigkeitenStatus =
    | "AKTIV"
    | "INAKTIV"
    | "AKTIVIERUNGAUSSTEHEND"
    | "NICHTANGEFORDERT";

export type KontoFaehigkeiten = {
    karte: KontoFaehigkeitenStatus;
    sepa: KontoFaehigkeitenStatus;
    giropay: KontoFaehigkeitenStatus;
    aufRechnung: KontoFaehigkeitenStatus;
};

export class KontostatusSammlung {
    public static readonly aktiv: Kontostatus = "AKTIV";
    public static readonly angabenErforderlich: Kontostatus = "ANGABENERFORDERLICH";
    public static readonly eingeschraenkt: Kontostatus = "EINGESCHRAENKT";
    public static readonly gebuehrenDeaktiviert: Kontostatus = "GEBUEHRENDEAKTIVIERT";
    public static readonly auszahlungenDeaktiviert: Kontostatus = "AUSZAHLUNGENDEAKTIVIERT";
}

export default class StripeKontoClient extends UiJsonApiClient {
    public constructor() {
        super("stripekonto");
    }

    public readonly kontoLaden = (): Promise<Konto | null> => {
        return this.get<Konto | null>("kontoLaden");
    }

    public readonly kontoFaehigkeitenLaden = (): Promise<KontoFaehigkeiten | null> => {
        return this.get<KontoFaehigkeiten | null>("kontoFaehigkeitenLaden");
    }

    public readonly kontoVerknuepfen = (): Promise<Konto> => {
        return this.post("kontoVerknuepfen");
    }

    public readonly kontoLoesen = async (): Promise<void> => {
        await this.post("kontoLoesen");
    }

    public readonly kontoWiederherstellen = async (): Promise<void> => {
        await this.post("kontoWiederherstellen");
    }

    public readonly kontoLinkErstellen = (refreshUrl: string, returnUrl: string): Promise<KontoLink> => {
        return this.get("kontoLinkErstellen", { refreshUrl, returnUrl });
    }

    public readonly geloestesKontoLaden = (): Promise<string | null> => {
        return this.getText("geloestesKontoLaden");
    }
}